// extracted by mini-css-extract-plugin
export default {"downloadIcon":"downloadVolumeData_downloadIcon__RMdSN","labelSection":"downloadVolumeData_labelSection__iNEol","downloadSmall":"downloadVolumeData_downloadSmall__W+icO"};